import { useCallback, useMemo } from 'react';
import { useAuthz } from '@ohpen/react-authz';

import { defaultSectionPath } from '@config';
import { isPermission } from '@pmp/contexts';

/**
 * Each configuration section is a resource of its own, named after the section it guards, so a
 * section the account cannot view is neither routed nor listed in the module's side bar.
 * `landingPath` is undefined when the module is switched off or the account may open no section.
 */
export const useConfigAccess = () => {
  const { userPermissions, envFeatureFlags } = useAuthz();

  const canViewSection = useCallback(
    (sectionKey: string) => {
      const permission = `config${sectionKey.charAt(0).toUpperCase()}${sectionKey.slice(1)}:view`;
      return isPermission(permission) && userPermissions.has(permission);
    },
    [userPermissions],
  );

  const landingPath = useMemo(
    () => (envFeatureFlags.has('enableConfig') ? defaultSectionPath(canViewSection) : undefined),
    [canViewSection, envFeatureFlags],
  );

  return { canViewSection, landingPath };
};
